import React from 'react';
import {
  Button,
  Form,
  Modal,
} from "react-bootstrap"

const Popup = ({
  row,
  onChange,
  onApplyChanges,
  onCancelChanges,
  open,
}) => {
  return (
    <Modal
      show={open}
      onHide={onCancelChanges}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Standard Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
              name="STANDARD_NAME"
              value={row.STANDARD_NAME}
              onChange={onChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Keterangan</Form.Label>
            <Form.Control
              name="STANDARD_DESC"
              value={row.STANDARD_DESC}
              onChange={onChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancelChanges}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onApplyChanges}>Save</Button>
      </Modal.Footer>
    </Modal>
  )
};

export default Popup;